// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__pp40e","progress":"style_progress__5NSW9"};